import { render } from "./indextenfooter.vue?vue&type=template&id=1cc2645d"
import script from "./indextenfooter.vue?vue&type=script&lang=js"
export * from "./indextenfooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__